<template>
  <div>
    <select-shop :loadingButton="loadingButton" v-on:getData="getSellReport"></select-shop>
    <div v-if="isPermission">
      <CCard class="shadow-sm">
        <CCardBody>
          <div class="row">
            <div class="col-md-10 col-8 col-sm-10 d-inline-flex align-items-center">
            <h2 id="sellTitle"  class="mb-0 font-weight-normal">
              {{ $t('report.txtsellbyProduct') }}
            </h2>
            <HelpButton :isHeader="false" class="ml-2"></HelpButton>
            </div>
            <div class="col-md-2 col-4 col-sm-3 text-right text-success">
              <CButton
                id="sellExportButton"
                v-if="isExport"
                :disabled="exportLoading"
                v-on:click="exportSellReport()"
                block
                color="info"
                >
                <span v-if="exportLoading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                <img v-else src="/img/file-excel.png" alt="Excel Icon" style="width: 16px; height: 16px; margin-right: 8px; vertical-align: middle; position: relative; top: -2px;" />
                <span>{{ exportLoading ? ($t('exporting') || 'กำลังส่งออก...') : $t('export') }}</span>
              </CButton>
            </div>
          </div>
          <CRow>
            <CCol sm="12" lg="12">
              <show-date></show-date>
              <hr />
              <div style="overflow-x:auto;">
                <DataTable id="sellDatatable" style="white-space: nowrap;" :items="items()" :fields="fields" :loading="loading" hover
                  border>
                  <template #discountAmount="{ item }">
                    <td v-if="item.discountAmount > 0.00" class="text-right text-danger">-{{ item.discountAmount }}</td>
                    <td v-else class="text-right text-dark">{{ item.discountAmount }}</td>
                  </template>
                </DataTable>
              </div>
            </CCol>
          </CRow>
          <pagination :meta_data="meta_data" v-on:next="getSellReport">
          </pagination>
        </CCardBody>
      </CCard>
    </div>
    <div v-else>
      <access-data></access-data>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axios from '@/services/service'
import report from '@/services/report'
import Pagination from '@/containers/Pagination'
import util from '@/util/util'
import DataTable from '@/containers/DataTable'
import permis from '@/util/permission'
import HelpButton from '../../containers/HelpButton.vue'

export default {
  components: {
    Pagination,
    DataTable,
    HelpButton
  },
  data() {
    return {
      data: [],
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: null,
        itemCount: null,
      },
      loadingButton: true,
      exportLoading: false
    }
  },
  computed: {
    ...mapGetters(['shops', 'date', 'users', 'permissions']),
    isPermission() {
      return permis.findPermissionRead('report', this.$route.path)
    },
    isExport() {
      return permis.findPermissionExport('report', this.$route.path)
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId
      },
      set(newValue) {
        return this.$store.dispatch('setShop', newValue)
      },
    },
    uid() {
      return `${localStorage.getItem('shopsUid')}`
    },
    startDate() {
      return moment(String(this.date.start)).format('DD MMMM YYYY')
    },
    endDate() {
      return moment(String(this.date.end)).format('DD MMMM YYYY')
    },
    fields() {
      return [
        { key: 'date', label: this.$i18n.t('date'), _classes: 'text-left text-dark font-weight-normal', },
        { key: 'receiptNumber', label: this.$i18n.t('receiptNumber'), _classes: 'text-left text-dark font-weight-normal', },
        { key: 'productPLU', label: this.$i18n.t('pluCode'), _classes: 'text-left text-dark font-weight-normal', },
        { key: 'name', label: this.$i18n.t('productName'), _classes: 'text-left text-dark font-weight-normal', },
        {
          key: 'quantitySKU',
          label: this.$i18n.t('quantity'),
          _classes: 'text-right text-dark font-weight-normal',
        },
        {
          key: 'price',
          label: this.$i18n.t('priceUnit'),
          _classes: 'text-right text-dark font-weight-normal',
        },
        {
          key: 'optionPrice',
          label: this.$i18n.t('optionTotal'),
          _classes: 'text-right text-dark font-weight-normal',
        },
        {
          key: 'totalAmount',
          label: this.$i18n.t('netAmount'),
          _classes: 'text-right text-dark font-weight-normal',
        },
        {
          key: 'discountAmount',
          label: this.$i18n.t('discount'),
          _classes: 'text-right text-dark font-weight-normal',
        },
        {
          key: 'netAmount',
          label: this.$i18n.t('totalAmount'),
          _classes: 'text-right text-dark font-weight-normal',
        },
      ]
    },

  },
  created() {
    this.getSellReport()
  },
  methods: {
    ...util,
    items() {
      return this.data
        .filter(item => (item.receiptItems && item.receiptItems.deleted_at == null))
        .map(item => {
          let receiptItems = item.receiptItems || {};
          let orderedOptions = receiptItems.orderedOptions || [];
          let optionPrice = orderedOptions.reduce((sum, opt) => {
            return sum + (opt.price || 0);
          }, 0);

          let discountBillPerQty = receiptItems.discountBillPerQty || 0;
          let discountAmount = receiptItems.discountAmount || 0;
          let quantitySKU = receiptItems.quantitySKU || 0;
          let discountBillPerQtyCal = discountBillPerQty * quantitySKU;
          let discount = discountBillPerQtyCal + discountAmount;

          let total = (receiptItems.netAmount || 0) - (receiptItems.discountBillPerQty || 0);

          let classes = 'text-dark';
          if (item.receiptStatus === 'V') classes = 'text-danger';
          else if (item.receiptStatus === 'W') classes = 'text-warning';

          return {
            date: moment(String(item.payReceiptAt)).format('DD/MM/YYYY HH:mm:ss'),
            receiptNumber: item.receiptNumber || '-',
            productPLU: receiptItems.productPLU?.PLUCode || '',
            name: receiptItems.productPLU?.name || '',
            quantitySKU: quantitySKU,
            price: util.convertCurrency(receiptItems.price || 0),
            totalAmount: util.convertCurrency(receiptItems.totalAmount || 0),
            discountAmount: util.convertCurrency(discount),
            netAmount: util.convertCurrency(total),
            _classes: classes,
            optionPrice: util.convertCurrency(optionPrice)
          };
        });
    },
    getSellReport(page = 1) {
      this.loadingButton = false
      this.loading = true
      const uid = `${localStorage.getItem('shopsUid')}`
      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')
      const params = {
        shopObjectId: this.shopObjectId,
        startAt: startAt,
        endAt: endAt,
        page: page,
        limit: 50,
      }
      const headers = {
        shopObjectId:util.sanitizeShopObjectId( this.shopObjectId),
      }
      axios({
        url: '/receipt/v1.0/productsellreport/' + uid + '/data',
        params: params,
        headers: headers,
        method: 'GET',
      })
        .then((res) => {
          this.data = res.data.data
          if (res.data.paginate.items == undefined) {
            this.meta_data.items = 0
          } else {
            this.meta_data.items = res.data.paginate.items
          }
          this.meta_data.last_page = res.data.paginate.pageCount
          this.meta_data.current_page = res.data.paginate.currentPage
          this.meta_data.itemCount = res.data.paginate.itemCount
          this.meta_data.limit = res.data.paginate.perPage
          this.loading = false
          this.loadingButton = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    exportSellReport() {
      // กันการกดซ้ำขณะกำลังดาวน์โหลด
      if (this.exportLoading) return
      this.exportLoading = true

      const uid = `${localStorage.getItem('shopsUid')}`
      const shopObjectId = this.shopObjectId

      const startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
      const endAt = moment(String(this.date.end)).format('YYYY-MM-DD')

      const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
      }
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) }

      report({
        url: `/receipt/v1.0/productsellreport/${uid}/excel`,
        params,
        method: 'GET',
        headers,
        responseType: 'blob', // important
      })
        .then((response) => {
          const blob = new Blob([response.data])
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'รายงานการขายตามรายการสินค้า.xlsx')
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          if (error?.response?.status === 429) {
            // แจ้งลูกค้าให้รอ 3 นาทีแล้วลองใหม่
            window.alert(this.$t('waitPreviousDownload', { minutes: 3 }))
          } else {
            console.log(error)
            // (เลือกใช้) แจ้ง error ทั่วไปของโปรเจกต์ เช่น toast/alert
            // window.alert('ไม่สามารถส่งออกไฟล์ได้ กรุณาลองใหม่อีกครั้ง')
          }
        })
        .finally(() => {
          this.exportLoading = false
        })
    }

  },
}
</script>
